import { Component, OnInit } from '@angular/core';
import { BreadcrumbService, BreakpointService } from '@library/core/services';
import { ScheduleReportService } from './schedule-report.service';
import { BehaviorSubject, Observable, Subject, of, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RelativeDateService } from '@library/common';
import * as moment from 'moment';
import 'moment-timezone';
import { RecurrenceTypes, scheduleGroup } from './schedule-report';
import { ReportDetailsService } from '../report.details.service';

@Component({
  selector: 'lib-schedule-report',
  templateUrl: './schedule-report.component.html',
  styleUrls: ['./schedule-report.component.scss'],
})
export class ScheduleReportComponent implements OnInit {
  reccurenceType$: Observable<any> = of(RecurrenceTypes);
  // showDays: boolean = false;
  reportId: any;
  dates = ['startDate', 'endDate'];
  toggleColor = 'primary';
  browserTimezone;

  _onDestroy: Subject<void> = new Subject();
  routeSub: BehaviorSubject<any> = new BehaviorSubject('');
  accountId: number;
  loading: boolean;
  saving: boolean = false;
  timeChecked: boolean = false;
  dateComparison: number = -1;
  
  constructor(
    private breadcrumbs: BreadcrumbService,
    private router: Router,
    public scheduleReport: ScheduleReportService,
    public breakpoints: BreakpointService,
    public relativeDates: RelativeDateService,
    private report: ReportDetailsService,
    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {
    this.breadcrumbs.newCrumb({ label: 'Reports', path: '/report' });
    

    this.route.params.subscribe(params => {
      // console.log(params) //log the entire params object
      // console.log(params['id']) //log the value of id
      this.reportId = params['id'];
      this.routeSub.next(params['id']);
    });

    this.report.load( this.reportId ).subscribe((data:any) => {
      this.breadcrumbs.addCrumb({ label: data.name, path: `/report/edit/${this.reportId}` });
      this.breadcrumbs.addCrumble('Scheduling');
    });

    this.scheduleReport.reset();

    this.browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    this.loading = true;
    this.scheduleReport.load(this.reportId).pipe(
      // this.scheduleReport.load().pipe(
      takeUntil(this._onDestroy),
    ).subscribe((rec:any) => {
      
      this.scheduleReport.scheduleForm = scheduleGroup(
        this.scheduleReport.schedule ?? rec[0]);

        this.timeCompare();

      if (this.scheduleReport.startDate) {
        // this.weekConvert(this.scheduleReport?.startDate);
        this.scheduleReport.startDate = this.dateConvert(this.scheduleReport.startDate);
      }
  
      if (this.scheduleReport.endDate) {
        this.scheduleReport.endDate = this.dateConvert(this.scheduleReport.endDate);
      }

      if(this.scheduleReport.frequency_week){
        this.scheduleReport.frequency_week = this.initWeekFrequency(this.scheduleReport.frequency_week);
      }

      if(this.scheduleReport.frequency_month){
        this.scheduleReport.frequency_month = this.initMonthTime(this.scheduleReport.frequency_month);
      }

      this.dates.map(d => this.scheduleReport.scheduleForm?.get(d))
        .map(c => c.value ? c.setValue(this.relativeDates.getIsoDate(c.value)) : c);

      if (this.scheduleReport.scheduleForm?.get('recurrence_period').value) {
        this.setRecType(this.scheduleReport.scheduleForm.get('recurrence_period').value);
      }

      if (this.scheduleReport.startTime) {
        this.scheduleReport.startTime = this.startTimeConvert();
      }

      this.scheduleReport.reportName$.subscribe(x => {
        this.scheduleReport.scheduleForm?.get('schedule_name').setValue(this.scheduleReport.scheduleForm.get('schedule_name').value || x);
      })

      // this.routeSub.subscribe(id => {
      //   this.scheduleReport.scheduleForm?.get('id').setValue(this.scheduleReport.scheduleForm.get('id').value || id)
      // });

      this.loading = false;
    })

    // this.accountService.active.pipe(take(1))
    //   .subscribe(a => this.accountId = a.id);

  }

  ngOnDestroy() {
    this.scheduleReport.reset();

    this._onDestroy.next();
    this._onDestroy.complete();
    this.routeSub.unsubscribe();
  }

  save() {
    this.saving = true;
    this.sanitizeData();
    let reportMapped = this.mapReport(this.scheduleReport.scheduleForm.value);
    // console.log("this.scheduleReport.recurrenceForm", this.scheduleReport.scheduleForm.value);
    console.log("reportMapped", reportMapped);
    this.scheduleReport.scheduleReport(reportMapped).subscribe(_ => {
      // const id = this.scheduleReport.scheduleForm.get('id').value;
      // this.router.navigate(['/report'])
      this.saving = false;
      this.router.navigate([`report/edit`, this.reportId || '']);
    });
  }

  setRecType(value: any) {
    this.scheduleReport.recTypeSelected$.next(value);
    this.scheduleReport.types = value;
  }

  cancel() {
    // const id = this.scheduleReport.scheduleForm.get('id').value;
    this.router.navigate([`report/edit`, this.reportId || '']);
  }

  sanitizeData() {
    let form = this.scheduleReport.scheduleForm;

    // DATES
    form.get('startDate').setValue(moment(form.get('startDate').value, ['Y-MM-DD', 'MM/DD/YYYY']).format('Y-MM-DD'));
    if (form.get('endDate').value) {
      form.get('endDate').setValue(moment(form.get('endDate').value, ['Y-MM-DD', 'MM/DD/YYYY']).format('Y-MM-DD'));
    }

    // FREQUENCY_WEEK
    // form.get('frequency_week').setValue(this.convertWeekFrequency(form.get("frequency_week").value));

    // TIMEZONE
    form.get('timezone').setValue(this.browserTimezone);

    // RECIPIENTS
    if (form.get('recipients').value.length >= 1) {
      let recipient = form.get('recipients').value;
      for (var i = recipient.length - 1; i >= 0; i--) {
        if (Object.values((recipient[i])).every(x => x === null || x === '')) {
          recipient.splice(i, 1);
        }
      }

    }

  }

  mapReport(data: any) {
    return {
      "schedule_details": {
        "schedule_name": data.schedule_name.replace(/\s{2,}/g, ' ').trim(),
        "schedule_description": data.schedule_description.replace(/\s{2,}/g, ' ').trim(),
        "active": data.active,
        "startDate": this.dateConvert(data?.startDate,'UTC'),
        "endDate": data?.endDate ? this.dateConvert(data?.endDate,'UTC') : null,
        "report_id": this.reportId
      },
      schedule_data: {
        "recurrence_period": data.recurrence_period,
        "no_end_date": data.no_end_date,
        "timezone": data.timezone,
        "startTime": this.startTimeConvert('UTC'),
        "frequency_week": data?.frequency_week ? this.updateWeekFrequency(this.scheduleReport.frequency_week) : [],
        "frequency_month": data?.frequency_month ? this.updateMonthTime(data?.frequency_month) : []
      },
      recipients: data.recipients,
      id: data.id || null,
    }
  }

  updateWeekFrequency(days) {
    if(!days) {return;}

    let dayToNumber = {
      "mon": 1,
      "tue": 2,
      "wed": 3,
      "thu": 4,
      "fri": 5,
      "sat": 6,
      "sun": 0
    };
    
    days = days.map((day:any) => dayToNumber[day]);

    let converted = this.updateDays(days,this.scheduleReport.types);
    return converted;
  }

  initWeekFrequency(days) {
    
    if(!days) {return;}

    let numberToDay = {
       1: "mon",
       2: "tue",
       3: "wed",
       4: "thu",
       5: "fri",
       6: "sat",
       0: "sun"
    };

    days = this.initDays(days,this.scheduleReport.types);
    // console.log("days2",numberToDay[days]);
    return days.map(day => numberToDay[day]);
 }

 updateMonthTime(days) {
  if(!days) {return;}

  let converted = this.updateDays(days,this.scheduleReport.types);
  return converted;
}

 initMonthTime(days) {
  if(!days) {return;}

  days = this.initDays(days,this.scheduleReport.types);

  return days;

  // return days.map(day => numberToDay[day]);
}

initDays(days:any,period:string){
  if(!days) {return;}
  
   return days.map((day:any) => {
    let ret;
    day = Number(day);

    if(this.dateComparison == 1){

      ret = day + 1;

      if(ret === 7 && period == 'weekly'){
        ret = 0;
      }
      if(ret === 32 && period == 'monthly'){
        ret = 1;
      }
    } else if(this.dateComparison == 2){
      ret = day - 1;
      if(ret === -1 && period == 'weekly'){
        ret = 6;
      }
      if(ret === 0 && period == 'monthly'){
        ret = 31;
      }
    } else {
      ret = day;
    } 
    return ret;
  })
 }

updateDays(days:any,period:string){
  if(!days) {return;}

  return days.map(day => {
    let ret;
    if(this.dateComparison == 1){
      ret = day - 1;
      if(ret === -1 && period == 'weekly'){
        ret = 6;
      }
      if(ret === 0 && period == 'monthly'){
        ret = 31;
      }
    } else if(this.dateComparison == 2){
      ret = day + 1;
      if(ret === 7 && period == 'weekly'){
        ret = 0;
      }
      if(ret === 32 && period == 'monthly'){
        ret = 1;
      }
    } else {
      ret = day;
    } 
    return ret;
  })

}

  startTimeConvert(tz?:string){
    let startTime;
    if(tz == 'UTC'){
      let localMoment = moment.tz((moment().format('YYYY-MM-DD')+" "+this.scheduleReport.startTime),this.browserTimezone);
      startTime = localMoment.utc().format('HH:mm');
    } else {
      let utcMoment = moment.tz((moment().format('YYYY-MM-DD')+" "+this.scheduleReport.startTime),'UTC');
      startTime = utcMoment.tz(this.browserTimezone).format('HH:mm');
    }
    return startTime;

  }

  dateConvert(date:string, tz?:string){
    let retDate;
    let currentLocalTime = moment().format('HH:mm:ss');

    if(tz == 'UTC'){
      let localMoment = moment.tz(date + " " + currentLocalTime,this.browserTimezone);
      retDate = localMoment.utc().format('YYYY-MM-DD HH:mm:ss');
    } else {
      let utcMoment = moment.tz(date,'UTC');
      retDate = utcMoment.tz(this.browserTimezone).format('YYYY-MM-DD');
    }

    return retDate;

  }

  timeCompare(){
    const nowLocal = moment().tz(this.browserTimezone);
    const localDay = nowLocal.date();

    // Convert local date to UTC and get the day
    const nowUtc = nowLocal.utc();
    const utcDay = nowUtc.date();

    // Compare days
    if (utcDay - localDay == -1) {
      this.dateComparison = 1; // Local date is after UTC date
    } else if (utcDay - localDay == 1) {
      this.dateComparison = 2; // Local date is before UTC date
    } else {
      this.dateComparison = 0; // Dates are the same
    }

  }

}
